import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProdutoLote } from '../../../core/models/produtos/produto-lote';
import { ProdutoPromocional } from '../../../core/models/produtos/produto-promocional';

/**
 * Conteúdo (corpo) do `<ng-template #adicionarItensLotes let-modal>` do componente pai
 * (pedido-adicionar-itens-modal.component.html:318-366 na árvore atual — os limites citados no
 * brief original (~1652/1661/1697/1704) estavam defasados pelas extrações das Tasks 3-8;
 * reancorado via `grep -n "adicionarItensLotes"`).
 *
 * Escopo: SOMENTE o `modal-body` (campo somente-leitura "Produto:" + tabela de lotes do produto —
 * nome, estoque, validade, preço unitário — clique na linha seleciona o lote). O `<ng-template>`,
 * `#adicionarItensLotes`, `modal-header` (319-325), `modal-footer` (363-365) e o método abridor
 * `modalAdicionarItensLotes(content, id_produto)` (ts:5507) permanecem intocados no pai.
 *
 * `selecionarLoteProduto(id_lote: number)` (ts:5327, grep-verificado) é o único método consumido
 * pelo corpo original — mesmo padrão de reemissão via @Output usado nas Tasks 4-8 (nenhuma lógica
 * de negócio duplicada aqui).
 */
@Component({
  selector: 'app-pedido-itens-modal-lotes',
  standalone: false,
  templateUrl: './pedido-itens-modal-lotes.component.html',
  styleUrls: ['./pedido-itens-modal-lotes.component.scss']
})
export class PedidoItensModalLotesComponent {
  /* Rótulo somente-leitura do produto atual — mesmo objeto do pai (ts:182:
     `produtoLotesSelecionado: ProdutoPromocional = null`), usado apenas para exibir `.name`. */
  @Input() produtoSelecionado: ProdutoPromocional = null;

  /* Lista de lotes do produto (ts:181: `produtoLotes: ProdutoLote[] = []`). */
  @Input() lotes: ProdutoLote[] = [];

  /** Reemite o `id` do lote clicado — mesmo argumento passado originalmente a
   *  `selecionarLoteProduto(id_lote: number)` (ts:5327). */
  @Output() loteSelecionado = new EventEmitter<number>();
}
